import { Insight } from "@/types/insights"
import { InsightPreset } from "@/types/insights/presets/insightPreset"

export function arePresetOptionsValid (insight: Insight, presets: InsightPreset[]): boolean {
	if (!insight.presetKey) {
		return true
	}

	const preset = presets?.find(p => p.id === insight.presetKey)
	if (!preset) {
		return false
	}

	return preset.parameters.every(param => {
		if (!param.isRequired) {
			return true
		}

		const value = insight.presetParameters ? insight.presetParameters[param.id] : null
		return value !== undefined && value !== null && value !== "" &&
			!(Array.isArray(value) && value.length === 0)
	})
}
